import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import AdminList from '@/components/AdminList'
import AdminSublist from '@/components/AdminSublist'
import AdminThisdata from '@/components/AdminThisdata'
import Addawards from '@/components/Addawards'
import Setawards from '@/components/Setawards'
import AdminThissub from '@/components/AdminThissub'
import Adduser from '@/components/Adduser'
import Search from '@/components/Search'
import List from '@/components/List'
import Result from '@/components/Result'
import Sublist from '@/components/Sublist'
import Thissub from '@/components/Thissub'
import Thisdata from '@/components/Thisdata'
import ApplicationList from '@/components/ApplicationList'
import AddEnterpriseName from '@/components/AddEnterpriseName'
import Index from '@/components/Index'
import store from './../store';

Vue.use(Router)

const routes = [
  // { //暂时不用
  //   path: '/admin/thisdata/:id',
  //   name: 'adminthisdata',
  //   component: AdminThisdata
  // },
  // { //暂时不用
  //   path: '/admin/thissub/thisdata/:id/:subid',
  //   name: 'adminthissub',
  //   component: AdminThissub
  // },
  // { //暂时不用
  //   path: '/admin/addawards',
  //   name: 'addawards',
  //   component: Addawards
  // },
  // { //暂时不用
  //   path: '/admin/setawards/:id',
  //   name: 'setawards',
  //   component: Setawards
  // },
  // { //暂时不用
  //   path: '/admin/adduser',
  //   name: 'adduser',
  //   component: Adduser
  // },
  // { //暂时不用
  //   path: '/list',
  //   name: 'list',
  //   component: List
  // },
  // { //暂时不用
  //   path: '/search/result/:value/',
  //   name: 'result',
  //   component: Result
  // },
  // { //暂时不用
  //   path: '/list/sublist/:id',
  //   name: 'sublist',
  //   component: Sublist
  // },
  // { //暂时不用
  //   path: '/list/thissub/thisdata/:id/:subid',
  //   name: 'thissub',
  //   component: Thissub
  // },
  // { //暂时不用
  //   path: '/list/thisdata/:id',
  //   name: 'thisdata',
  //   component: Thisdata
  // }
]
export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'search',
    //   component: Search
    // },
    {   //2021.06.29新增行业测评首页
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/search/result/',
      name: 'result',
      component: Result
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    { //权限
      path: '/admin/list',
      name: 'adminlist',
      component: AdminList,
      beforeEnter:(to, from, next) => {
        if(store.getters.role){ //判断role 是否存在
          if(store.getters.newrouter.length !== 0){  
               next();
          }else{
               if (store.getters.role == 'B') {  //判断权限
                    next();
                } else {
                    next('/login');
                }
          }	  
        }else{
            if (['/login'].indexOf(to.path) !== -1) { 
               next()
            } else {
              next('/')
            }
        }
      },
      meta:{role: 'B'}
    },
    { //权限
      path: '/admin/sublist/:id',
      name: 'adminsublist',
      component: AdminSublist,
      beforeEnter:(to, from, next) => {
        if(store.getters.role){ //判断role 是否存在
          if(store.getters.newrouter.length !== 0){  
               next();
          }else{
               if (store.getters.role == 'B') {  //判断权限
                    next();
                } else {
                    next('/login');
                }
          }	  
        }else{
            if (['/login'].indexOf(to.path) !== -1) { 
               next()
            } else {
              next('/')
            }
        }
      },
      meta:{role: 'B'}
    },
    { //权限
      path: '/admin/addenterprisename',
      name: 'AddEnterpriseName',
      component: AddEnterpriseName,
      beforeEnter:(to, from, next) => {
        if(store.getters.role){
          if(store.getters.newrouter.length !== 0){  
                  next();
            }else{
                  if (store.getters.role == 'B') {  //判断权限
                      next();
                  } else {
                      next('/login');
                  }
            }	  
          }else{
              if (['/login'].indexOf(to.path) !== -1) { 
                  next()
              } else {
                next('/')
              }
          }
        },
        meta:{role: 'B'}
    },
    {
      path: '/applicationlist',
      name: 'applicationlist',
      component: ApplicationList
    }
  ]  
});



// WEBPACK FOOTER //
// ./src/router/index.js